import {setScreen} from '../../services/router';
import LoginForm from './LoginForm/LoginForm';

export default function AuthLoginPage() {
  return <LoginForm />;
}
